module.exports = __webpack_public_path__ + "static/img/int-img.89b6718.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/int-img.png
// module id = g7u2
// module chunks = 1